export const IMG = {
  heroBedroom: "https://images.unsplash.com/photo-1590490360182-c33d57733427?q=80&w=1920&auto=format&fit=crop",
  bedroom2: "https://images.unsplash.com/photo-1549638441-b787d2e11f14?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  hotelRoom: "https://images.unsplash.com/photo-1590490360182-c33d57733427?q=80&w=1600&auto=format&fit=crop",
  hotelRoom2: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?q=80&w=1600&auto=format&fit=crop",
  resort: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=1600&auto=format&fit=crop",
  towels: "https://images.pexels.com/photos/7691101/pexels-photo-7691101.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  bathrobe: "https://images.pexels.com/photos/36845215/pexels-photo-36845215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  fabric: "https://images.pexels.com/photos/17734751/pexels-photo-17734751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  lobby: "https://images.unsplash.com/photo-1625244724120-1fd1d34d00f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dining: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=1600&auto=format&fit=crop",
};

export const CONTACT = {
  address: "26 Mookambikai Nagar, Teachers Colony, Karamadai, Coimbatore, Tamil Nadu, India - 641104",
  addressLines: ["26 Mookambikai Nagar,", "Teachers Colony,", "Karamadai,", "Coimbatore,", "Tamil Nadu,", "India - 641104"],
  phonePrimary: "+91 76038 10376",
  phones: ["+91 76038 10376", "+91 94891 66505", "+91 99947 42982", "+91 90807 08371"],
  email: "contactus.amazinggrace@gmail.com",
  gstin: "33ACBFA0190J1ZS",
  pan: "ACBFA0190J",
  whatsapp: "https://wa.me/917603810376?text=Hello%20Amazing%20Grace%2C%20I%20would%20like%20to%20enquire%20about%20your%20hospitality%20textiles.",
  mapsEmbed: "https://www.google.com/maps?q=Mookambikai%20Nagar%2C%20Teachers%20Colony%2C%20Karamadai%2C%20Coimbatore%2C%20Tamil%20Nadu%20641104&output=embed",
};

export const SOCIALS = {
  youtube: "https://www.youtube.com/",
  instagram: "https://www.instagram.com/",
  linkedin: "https://www.linkedin.com/",
};

export const CATEGORIES = [
  {
    id: "bedding",
    title: "Bedding & Bed Linen",
    desc: "Crisp, considered bedding for rooms that guests remember.",
    image: IMG.hotelRoom,
    items: ["Bed Sheets", "Bed Runners", "Duvets", "Duvet Covers", "Pillows", "Pillow Covers", "Mattresses", "Mattress Protectors"],
  },
  {
    id: "bath",
    title: "Bath & Towel Collection",
    desc: "Soft, absorbent bath textiles built for daily hospitality use.",
    image: IMG.towels,
    items: ["Bath Towels", "Pool Towels", "Hand Towels", "Face Towels", "Bath Mats", "Bath Robes"],
  },
  {
    id: "hospitality",
    title: "Hospitality Textiles",
    desc: "Finishing touches for dining rooms and shared spaces.",
    image: IMG.dining,
    items: ["Table Napkins", "Hospitality Linen Products"],
  },
  {
    id: "comfort",
    title: "Comfort & Room Essentials",
    desc: "Warm layers and accents that complete the guest experience.",
    image: IMG.fabric,
    items: ["Cushions", "Cushion Covers", "Fleece Blankets"],
  },
];

export const ESSENTIALS = [
  "Bed Linen", "Bath Linen", "Towels", "Pillows", "Mattresses",
  "Mattress Protectors", "Bathrobes", "Cushions", "Table Napkins", "Blankets",
];

export const CUSTOMERS = [
  "Radisson", "Le Méridien", "Lemon Tree Hotels", "Royal Oak",
  "ibis Hotels", "Vijay Elanza", "Leela Palace", "Grand Chola Hotels",
];

export const PRODUCT_OPTIONS = [
  "Bed Sheets", "Bed Runners", "Duvets", "Duvet Covers", "Pillows", "Pillow Covers",
  "Mattresses", "Mattress Protectors", "Bath Towels", "Pool Towels", "Hand Towels",
  "Face Towels", "Bath Mats", "Bath Robes",
  "Table Napkins", "Hospitality Linen Products", "Cushions", "Cushion Covers",
  "Fleece Blankets", "Complete Property Requirement", "Other",
];

export const MARQUEE_ITEMS = [
  "Bed Sheets", "Duvets", "Bath Towels", "Bathrobes", "Pillows",
  "Mattresses", "Table Napkins", "Fleece Blankets", "Bed Runners", "Bath Mats",
];
